export const environment = {
  production: false,
  hostUrl: 'https://bo-dev-yarrow-event-pulse.vthgdigital.com',
  apiUrl: 'https://dev-yarrow-event-pulse.vthgdigital.com/api/',
  websocket: 'https://dev-yarrow-event-pulse.vthgdigital.com',
  line: {
    adminShareLiffId: '2010231205-mjx36cAu',
    userEventLiffId: '2006998168-LK4Y0QkQ',
    userEventOpenBaseUrl: 'https://line.me/R/app/2006998168-LK4Y0QkQ',
  },
  GOOGLE_clientId:
    '140787760047-ujs11cosafdip2repaqnrs42vomde1pp.apps.googleusercontent.com',
  GOOGLE_apiKey: 'AIzaSyAZxseNJVM1A3nzMkang_gS9sejjZceI-E',
  LIFF_id: '2010231205-YKTZRcT7', // TODO: replace with your LINE Login LIFF ID for dev environment
};
